import { render, staticRenderFns } from "./model_management_form.vue?vue&type=template&id=7055b986&scoped=true"
import script from "./model_management_form.vue?vue&type=script&lang=js"
export * from "./model_management_form.vue?vue&type=script&lang=js"
import style0 from "./model_management_form.vue?vue&type=style&index=0&id=7055b986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7055b986",
  null
  
)

export default component.exports